import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { connect } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as SentryReact from '@sentry/react';
import * as SentryBrowser from '@sentry/browser';
import store from './redux/store';
import { IonLoading, setupIonicReact } from '@ionic/react';
import App from './App';
import { showLoading } from './redux/actions';
import FeedbackToast from './components/FeedbackToast';
import { ENVIRONMENT } from './api/graphql/endpoint';

if (ENVIRONMENT !== 'development') {
  SentryBrowser.init({
    dsn: "https://31e2aca3a6679c93f82dea1b4356b776@o4507756145803264.ingest.us.sentry.io/4507756153274368",
    release: "bomahut@v0.33",
    dist: "bomahut@v0.33",
    integrations: [
      SentryBrowser.browserTracingIntegration(),
      SentryReact.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
      }),
    ],
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/bomahut\.com\/api/],

    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  },
  );
}

const mapStateToProps = (state) => {
  return {
    fireLoader: state.showLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showLoader: (show) => dispatch(showLoading(show))
  };
};

const container = document.getElementById('root');
const root = createRoot(container);

const AppLoader = ({ fireLoader }) => {
  const [showLoading, setShowLoading] = useState(false);
  useEffect(() => {
    setShowLoading(Boolean(fireLoader));
  }, [fireLoader]);
  return (
    <>
      <IonLoading isOpen={showLoading} duration={10000} message={'Loading...'} />
    </>
  )
}

const AppLoaderContainer = connect(mapStateToProps, mapDispatchToProps)(AppLoader);

const startApp = () => {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <AppLoaderContainer />
        <FeedbackToast />
        <App />
      </Provider>
    </React.StrictMode>
  );
};

setupIonicReact();
startApp();
